<template>
  <!--<sr-header></sr-header>-->
  <!--<sr-nav></sr-nav>-->
  <div>
    <sr-header/>
    <div class="container">
      <sidebar-sr/>
      <el-scrollbar wrap-class="content">
        <router-view v-slot="{ Component }">
          <component :is="Component"/>
        </router-view>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import SrHeader from './sr-header'
import SidebarSr from './sidebar'

export default {
  name: 'Home',
  components: {
    SrHeader,
    SidebarSr
  },
  computed: {
    collapse() {
      return this.$store.state.base.collapse
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .container {
    display: flex;
    width: 100%;
    min-width: 1200px;
    height: calc(100vh - 86px);
    padding: 0 30px;
    box-sizing: border-box;
    position: relative;
  }

  .el-scrollbar {
    flex: 1;
  }

  .content {
    flex: 1;
    border-radius: 4px;
    overflow-x: hidden !important;
  }
</style>
